export const InBoundChartServices={
 
  
  getChart(leadDataArray, siteVisitDataArray, ceDataArray, FSADataArray, ContractDataArray, ConstructionDataArray){
      let chartData = [
          {
            data: [...leadDataArray],
            borderWidth: 1,
            hidden: false,
            label: 'Monthly Leads',
            fill: false,
            tension: 0.5,
            borderColor: 'red',
            backgroundColor: 'red'
          },
          {
            data: [...siteVisitDataArray],
            borderWidth: 1,
            hidden: false,
            label: 'Site Visit',
            fill: false,
            tension: 0.5,
            borderColor: 'green',
            backgroundColor: 'green'
          },
          {
            data: [...ceDataArray],
            borderWidth: 1,
            hidden: false,
            label: 'CE',
            fill: false,
            tension: 0.5,
            borderColor: 'blue',
            backgroundColor: 'blue'
          },
          {
            data: [...FSADataArray],
            borderWidth: 1,
            hidden: false,
            label: 'FSA',
            fill: false,
            tension: 0.5,
            borderColor: 'orange',
            backgroundColor: 'orange'
          },
          {
            data: [...ContractDataArray],
            borderWidth: 1,
            hidden: false,
            label: 'Contract',
            fill: false,
            tension: 0.5,
            borderColor: 'gray',
            backgroundColor: 'gray'
          },
          {
            data: [...ConstructionDataArray],
            borderWidth: 1,
            hidden: false,
            label: 'Construction',
            fill: false,
            tension: 0.5,
            borderColor: 'violet',
            backgroundColor: 'violet'
          }
        ]
      let chartLabels = [
          'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Set', 'Oct', 'Nov', 'Dec'
        ];
        let chartOptions = {
          maintainAspectRatio: false,
          aspectRatio: 0.6,
          plugins: {
              legend: {
                  labels: {
                      // color: 'red'
                  }
              }
          },
          scales: {
              x: {
                  ticks: {
                      // color: "blue"
                  },
                  grid: {
                      // color: "blue"
                  }
              },
              y: {
                  ticks: {
                      // color: "blue"
                  },
                  grid: {
                      // color: "blue"
                  }
              }
          }
      };
    
        return {  chartData, chartLabels, chartOptions }
     
  },

  FormatData(arrayOfObject) {
      let mapData = arrayOfObject.map((
        { 
          monthname, 
          monthly_leads, 
          site_visits, 
          site_visits_percentage, 
          ce_stage, 
          ce_percentage, 
          ce_sv_percentage,
          fsa_stage, 
          fsa_percentage, 
          fsa_ce_percentage, 
          npfsa, 
          npfsa_percentage, 
          contract_stage, 
          contract_percentage, 
          co_fsa_percentage, 
          contract_cancelled, 
          contract_cancelled_percentage, 
          construction_start_stage, 
          construction_start_percentage,
          cons_cont_percentage, 
          completion, 
          completion_percentage, 
          cm_cs_percentage, 
          warranty
      }) =>
      ({
        Month: monthname,
        Leads: monthly_leads,
        "Site V": site_visits,
        "Site V%": `${(Number(site_visits_percentage) * 100).toFixed(1)}%`,
        "CE": ce_stage,
        "CE %": `${(Number(ce_percentage) * 100).toFixed(1)}%`,
        "SV-CE%": `${Number(ce_sv_percentage * 100).toFixed(1)}%`,
        "Fsa": fsa_stage,
        "FSA %": `${(Number(fsa_percentage) * 100).toFixed(1)}%`,
        "CE-FSA%": `${Number(fsa_ce_percentage * 100).toFixed(1)}%`,
  
        "NPF": npfsa,
        "NPF %": `${(Number(npfsa_percentage) * 100).toFixed(1)}%`,
  
        "Cont": contract_stage,
        "Cont %": `${(Number(contract_percentage) * 100).toFixed(1)}%`,
        "FSA-CO%": `${Number(co_fsa_percentage * 100).toFixed(1)}%`,

        "CO-CAN": contract_cancelled,
        "CO-CAN%": `${Number(contract_cancelled_percentage * 100).toFixed(1)}%`,   

        "Cons": construction_start_stage,
        "Cons %": `${(Number(construction_start_percentage) * 100).toFixed(1)}%`,
        "CT-CO%": `${Number(cons_cont_percentage * 100).toFixed(1)}%`,
        'Comp': completion,
        'Comp %': `${(Number(completion_percentage) * 100).toFixed(1)}%`,
        "CO-CM%": `${Number(cm_cs_percentage * 100).toFixed(1)}%`,
        "Warranty": warranty
      }));
  
      return mapData;
    },
    AllTotaldata(val) {
      let totalLD = val.map((x) => x['monthly_leads']).reduce((t, v) => ((t == null) ? 0 : parseInt(t)) + ((v == null) ? 0 : parseInt(v)), 0);
      let totalSV = val.map((x) => x['site_visits']).reduce((t, v) => ((t == null) ? 0 : parseInt(t)) + ((v == null) ? 0 : parseInt(v)), 0);
      let SVPer = totalLD && totalSV ? `${(totalSV / totalLD * 100).toFixed(1)}%` : '';  
      let CEStage = val.map((x) => x['ce_stage']).reduce((t, v) => ((t == null) ? 0 : parseInt(t)) + ((v == null) ? 0 : parseInt(v)), 0);
      let CEPer = totalLD && CEStage ? `${(CEStage / totalLD * 100).toFixed(1)}%` : '';
      let cesvPer = totalSV && CEStage ? `${Number(CEStage / totalSV * 100).toFixed(1)}%` : '';
      let FSAStage = val.map((x) => x['fsa_stage']).reduce((t, v) => ((t == null) ? 0 : parseInt(t)) + ((v == null) ? 0 : parseInt(v)), 0);
      // let FSAPer = totalLD && FSAStage ? `${(FSAStage / totalLD * 100).toFixed(1)}%` : '';
      let FSAPer = totalSV && FSAStage ? `${(FSAStage / totalSV * 100).toFixed(1)}%` : '';
      let fsacePer = CEStage && FSAStage ? `${Number(FSAStage / CEStage * 100).toFixed(1)}%` : '';
      
      let Npsf = val.map((x) => x['npfsa']).reduce((t, v) => ((t == null) ? 0 : parseInt(t)) + ((v == null) ? 0 : parseInt(v)), 0);
      // let NpsfPer = totalLD && Npsf ? `${(Npsf / totalLD * 100).toFixed(1)}%` : '';
      let NpsfPer = FSAStage && Npsf ? `${(Npsf / FSAStage * 100).toFixed(1)}%` : '';
    
      let ContractStage = val.map((x) => x['contract_stage']).reduce((t, v) => ((t == null) ? 0 : parseInt(t)) + ((v == null) ? 0 : parseInt(v)), 0);
      let ContractPer = totalSV && ContractStage ? `${(ContractStage / totalSV * 100).toFixed(1)}%` : '';
      let cofsaPer = FSAStage && ContractStage ? `${Number(ContractStage / FSAStage * 100).toFixed(1)}%` : '';
    
      let ContractCancelled = val.map((x) => x['contract_cancelled']).reduce((t, v) => ((t == null) ? 0 : parseInt(t)) + ((v == null) ? 0 : parseInt(v)), 0);
      let ContractCancelled_per = ContractStage && ContractCancelled ? `${(ContractCancelled / ContractStage * 100).toFixed(1)}%` : '';
    
      let ConstStage = val.map((x) => x['construction_start_stage']).reduce((t, v) => ((t == null) ? 0 : parseInt(t)) + ((v == null) ? 0 : parseInt(v)), 0);
      let ConstPer = totalLD && ConstStage ? `${(ConstStage / totalLD * 100).toFixed(1)}%` : '';
      let scctPer = ContractStage && ConstStage ? `${Number(ConstStage / ContractStage * 100).toFixed(1)}%` : '';
    
      let CompleteStage = val.map((x) => x['completion']).reduce((t, v) => ((t == null) ? 0 : parseInt(t)) + ((v == null) ? 0 : parseInt(v)), 0);
      let compPer = totalLD && CompleteStage ? `${(CompleteStage / totalLD * 100).toFixed(1)}%` : '';
      let cmcsPer = ConstStage && CompleteStage ? `${Number(CompleteStage / ConstStage * 100).toFixed(1)}%` : '';
    
      let warranty = val.map((x) => x['warranty']).reduce((t, v) => ((t == null) ? 0 : parseInt(t)) + ((v == null) ? 0 : parseInt(v)), 0);
      let warrantyPer = warranty ? `${warranty}%` : '';

       // Calculate total for warranty
    let totalWarranty = val.map((x) => x['warranty'])
    .reduce((t, v) => ((t == null) ? 0 : parseInt(t)) + ((v == null) ? 0 : parseInt(v)), 0);
    
      let obj = {
        "Month": 'Total', 
        Leads: totalLD ? totalLD : '', 
        "Site V": totalSV ? totalSV : '', 
        "Site V%": SVPer, 
        "CE": CEStage ? CEStage : '', "CE %": CEPer, 
        "SV-CE%": cesvPer, 
        "Fsa": FSAStage ? FSAStage : '', "FSA %": FSAPer, 
        "CE-FSA%": fsacePer, 
        "NPF": Npsf ? Npsf : '', "NPF %": NpsfPer, 
        "Cont": ContractStage ? ContractStage : '', 
        "Cont %": ContractPer,
        "FSA-CO%": cofsaPer, 
    
        "CO-CAN": ContractCancelled ? ContractCancelled : '',
        "CO-CAN%": ContractCancelled_per, 
    
        "Cons": ConstStage ? ConstStage : '', 
        "Cons %": ConstPer, 
        "CT-CO%": scctPer, 
        "Comp": CompleteStage ? CompleteStage : '',
        "Comp %": compPer,
        "CO-CM%": cmcsPer,
        "Warranty Starts": CompleteStage ? CompleteStage : '',
        "Warranty Ends": warranty,
        "Warranty": totalWarranty 
      };
    
      return obj;
    }
    ,
    
    YearTotaldata(val, year) {
      let totalLD = val.map((x) => x['monthly_leads']).reduce((t, v) => ((t == null) ? 0 : t) + ((v == null) ? 0 : v), 0);
      let totalSV = val.map((x) => x['site_visits']).reduce((t, v) => ((t == null) ? 0 : t) + ((v == null) ? 0 : v), 0);
      let SVPer = totalLD && totalSV ? `${(totalSV / totalLD * 100).toFixed(1)}%` : '';
    
      let CEStage = val.map((x) => x['ce_stage']).reduce((t, v) => ((t == null) ? 0 : t) + ((v == null) ? 0 : v), 0);
      let CEPer = totalLD && CEStage ? `${(CEStage / totalLD * 100).toFixed(1)}%` : '';
      let cesvPer = totalSV && CEStage ? `${Number(CEStage / totalSV * 100).toFixed(1)}%` : '';
    
      let FSAStage = val.map((x) => x['fsa_stage']).reduce((t, v) => ((t == null) ? 0 : t) + ((v == null) ? 0 : v), 0);
      // let FSAPer = totalLD && FSAStage ? `${(FSAStage / totalLD * 100).toFixed(1)}%` : '';
      let FSAPer = totalSV && FSAStage ? `${(FSAStage / totalSV * 100).toFixed(1)}%` : '';
      let fsacePer = CEStage && FSAStage ? `${Number(FSAStage / CEStage * 100).toFixed(1)}%` : '';
    
      let Npsf = val.map((x) => x['npfsa']).reduce((t, v) => ((t == null) ? 0 : t) + ((v == null) ? 0 : v), 0);
      let NpsfPer = totalLD && Npsf ? `${(Npsf / totalLD * 100).toFixed(1)}%` : '';
    
      let ContractStage = val.map((x) => x['contract_stage']).reduce((t, v) => ((t == null) ? 0 : t) + ((v == null) ? 0 : v), 0);
      let ContractPer = totalSV && ContractStage ? `${(ContractStage / totalSV * 100).toFixed(1)}%` : '';
      let cofsaPer = FSAStage && ContractStage ? `${Number(ContractStage / FSAStage * 100).toFixed(1)}%` : '';
    
      let ContractCancelled = val.map((x) => x['contract_cancelled']).reduce((t, v) => ((t == null) ? 0 : t) + ((v == null) ? 0 : v), 0);
      let ContractCancelled_per = ContractStage && ContractCancelled ? `${(ContractCancelled / ContractStage * 100).toFixed(1)}%` : '';
    
      let ConstStage = val.map((x) => x['construction_start_stage']).reduce((t, v) => ((t == null) ? 0 : t) + ((v == null) ? 0 : v), 0);
      let ConstPer = totalLD && ConstStage ? `${(ConstStage / totalLD * 100).toFixed(1)}%` : '';
      let scctPer = ContractStage && ConstStage ? `${Number(ConstStage / ContractStage * 100).toFixed(1)}%` : '';
    
      let CompleteStage = val.map((x) => x['completion']).reduce((t, v) => ((t == null) ? 0 : t) + ((v == null) ? 0 : v), 0);
      let compPer = totalLD && CompleteStage ? `${(CompleteStage / totalLD * 100).toFixed(1)}%` : '';
      let cmcsPer = ConstStage && CompleteStage ? `${Number(CompleteStage / ConstStage * 100).toFixed(1)}%` : '';
      let warranty = val.map((x) => x['warranty']).reduce((t, v) => ((t == null) ? 0 : parseInt(t)) + ((v == null) ? 0 : parseInt(v)), 0);
    
      let obj = {
        year: year, 
        "Month": 'Total', 
        Leads: totalLD ? totalLD : '', 
        "Site V": totalSV ? totalSV : '', 
        "Site V%": SVPer, 
        "CE": CEStage ? CEStage : '', "CE %": CEPer, 
        "SV-CE%": cesvPer, 
        "Fsa": FSAStage ? FSAStage : '', "FSA %": FSAPer, 
        "CE-FSA%": fsacePer, 
        "NPF": Npsf ? Npsf : '', "NPF %": NpsfPer, 
        "Cont": ContractStage ? ContractStage : '', 
        "Cont %": ContractPer,
        "FSA-CO%": cofsaPer, 
    
        "CO-CAN": ContractCancelled ? ContractCancelled : '',
        "CO-CAN%": ContractCancelled_per, 
    
        "Cons": ConstStage ? ConstStage : '', 
        "Cons %": ConstPer, 
        "CT-CO%": scctPer, 
        "Comp": CompleteStage ? CompleteStage : '',
        "Comp %": compPer,
        "CO-CM%": cmcsPer,
        "Warranty Starts": CompleteStage ? CompleteStage : '',
        "Warranty Ends": warranty        
      };
    
      return obj;
    }    
    ,    
    getKeyData (){
      return [
        { "id": "Month", "name": "Month" },
        { "id": "Leads", "name": "Leads" },
        { "id": "Site V", "name": "SQL / Site Visit" },  //First Meeting
        { "id": "Site V%", "name": "Lead / SQL %" },
        { "id": "CE", "name": "Conceptual Estimate" },
        { "id": "CE %", "name": "Conceptual Estimate %" },
        { "id": "SV-CE%", "name": "SQL - Conceptual Estimate %" },
        { "id": "Fsa", "name": "Fsa Sign" },
        { "id": "FSA %", "name": "SQL - FSA Sign %" },
        { "id": "CE-FSA%", "name": "Conceptual Estimate-FSA%" },
        { "id": "NPF", "name": "FSA CANCELLED" },
        { "id": "NPF %", "name": "FSA CANCELLED %" },
        { "id": "Cont", "name": "Contract" },
        { "id": "Cont %", "name": "SQL - Contract %" },
        { "id": "FSA-CO%", "name": "FSA Sign-Contract %" },

        { "id": "CO-CAN", "name": "Contract Cancelled" },
        { "id": "CO-CAN%", "name": "Contract Cancelled %" },        

        { "id": "Cons", "name": "Construction Start" },
        { "id": "Cons %", "name": "Construction Start %" },
        { "id": "CT-CO%", "name": "Contract-Construction Start %" },
        { "id": "Comp", "name": "Construction Complete / Warranty Starts" },
        { "id": "Comp %", "name": "Construction Complete %" },
        { "id": "CO-CM%", "name": "Construction (Start-Complete)%" },
        // { "id": "Comp", "name": "Warranty Starts" },
        { "id": "Warranty", "name": "Warranty Complete" }
      ]
      
      // return ["Month", "Leads","Site V","Site V%","CE", "CE %","SV-CE%","Fsa", "FSA %","CE-FSA%", "NPF", "NPF %","Cont","Cont %", "FSA-CO%","Cons", "Cons %","CT-CO%",'Comp','Comp %',"CO-CM%", ]

    },
    OverAllAvgCounts(val){
 
      let arr = [
        { "TRACKING DATA": "Total Lost Jobs", "Leads": Math.floor(val[0].lost_jobs) },
        { "TRACKING DATA": "Total Turned Down", "Leads": Math.floor(val[0].turned_down_jobs) },
        { "TRACKING DATA": "Total FSA Cancelled", "Leads": Math.floor(val[0].not_proceeding_jobs) },
        { "TRACKING DATA": "Total Custom Home", "Leads": Math.floor(val[0].custom_home) },
        { "TRACKING DATA": "Total Renovations", "Leads": Math.floor(val[0].renovation) },
  
      ]
      return arr;
    },
    OverAllAvgDays(val) {
  
      let arr6 = [
        { "TRACKING DATA": "FROM CONTACT TO SITE VISIT", "Days": Math.floor(val[0].contact_to_site_visit_days) },
        { "TRACKING DATA": "FROM SITE VISIT TO CE", "Days": Math.floor(val[0].site_visit_to_ce_days) },
        { "TRACKING DATA": "FROM CE TO FSA", "Days": Math.floor(val[0].ce_to_fsa_days) },
        { "TRACKING DATA": "FROM FSA TO CONTRACT", "Days": Math.floor(val[0].fsa_to_contract_days) },
        { "TRACKING DATA": "CONSTRUCTION TO START", "Days": Math.floor(val[0].construction_to_start_days) },
      ]
      return arr6;
    }, 
    OverAllAvgCountHeader(){
      return ["TRACKING DATA", "Leads"]
    },
    OverAllDaysCountHeader(){
      return ["TRACKING DATA", "Days"]
    },
    getMarketingAndSeles(rawData,revItem){
      let totallead = rawData.length;

      var setCounts = {};
      rawData.forEach((v) => {
        setCounts[v['lead_source']] = (setCounts[v['lead_source']] || 0) + 1;
      });
      

      let bestLeadSource = Object.keys(setCounts).reduce((a, b) =>setCounts[a] > setCounts[b] ? a : b);

      let worstLeadSource = Object.keys(setCounts).reduce((a, b) => setCounts[a] < setCounts[b] ? a : b);

      let FilterRoiFromBLS = rawData.filter((x) => x['lead_source'] == bestLeadSource);

      // let RoiFromBLS = FilterRoiFromBLS.length > 0 ? FilterRoiFromBLS.map((c) => c['project_value']).reduce((t, v) => Number(t) + Number(v)) : 0;
     var RoiFromBLS = 0;
      if(FilterRoiFromBLS.length > 0){
        FilterRoiFromBLS.forEach(element => {
  
          if(element['project_value']!=null){
            if(element['project_value'].includes(',')){
              let val = element['project_value'].replace(/,/g, '');
              RoiFromBLS += Number(val);
            }else if(element['project_value'].includes('$')){
              let val = element['project_value'].replace('$', '');
              RoiFromBLS += Number(val);
            
            }else{
              RoiFromBLS += Number(element['project_value']);
            }


           
          }
          
        });
      }

      
      let FilterRoiFromWLS = rawData.filter((x) => x['lead_source'] == worstLeadSource);
      let RoiFromWLS = 0;// FilterRoiFromWLS.map((c: any) => c['project_value']).reduce((t: any, v: any) => Number(t) + Number(v));

      let refPeronalContact =
        rawData.filter((x) => x['lead_source'] == 'Personal Contact').length + rawData.filter((x) => x['lead_source'] == 'Referral').length;

        let googleLead = rawData.filter((x) => x['lead_source'] == 'Google').length;
        let repeatCustomer = rawData.filter((x) => x['lead_source'] == 'Repeat Customers').length;
  
        let notionalEst = rawData.filter((x) => x['ce_stage'] == 'CE').length;
        let leadConvent = `${(notionalEst / totallead * 100).toFixed(2)}%`;
        let closingSalesRatio = rawData.filter((x) => x['fsa_stage'] == 'FSA').length / rawData.filter((x) => x['ce_stage'] == 'CE').length;
        
        let first = rawData.filter((x)=> x['project_type'] !='Renovation' && x['site_visit_stage']=='SITE VISITS');
        let fVal = first.length > 0 ? first.map((x)=> x['project_value']).reduce((t, v) => Number(t) + Number(v))/first.length : 0;
  
        let second = rawData.filter((x)=> x['project_type'] !='Custom Home' && x['site_visit_stage']=='SITE VISITS');
        let sVal = second.length > 0 ? second.map((x)=> x['project_value']).reduce((t, v) => Number(t) + Number(v))/second.length : 0;
        let avJobSize = (fVal + sVal)/2;
  
        let reniSize = rawData.filter((x) => x['project_type'] == 'Renovation' && x['site_visit_stage'] == 'SITE VISITS');
        let reniSizeValValue = reniSize.length > 0 ? reniSize.map((x) => x['project_value']).reduce((t, v) => Number(t) + Number(v)) : 0;
        let reniSizeVal = (reniSizeValValue/reniSize.length); 
  
        let customHome = rawData.filter((x) =>x['project_type'] == 'Custom Home' && x['site_visit_stage'] == 'SITE VISITS');
        let customHomeSizeValue = customHome.length>0 ? customHome.map((x) => x['project_value']).reduce((t, v) => Number(t) + Number(v)) : 0;
        let customHomeSize = (customHomeSizeValue / customHome.length);
        
        let turnDownJob1 = rawData.filter((x) => x['declined_type'] == 'TURNED DOWN');
        let turnDownJoValue = turnDownJob1.length > 0 ? turnDownJob1.map((x) => x['project_value']).reduce((t, v) => Number(t) + Number(v)) : 0;
        
        let avTdVal = (turnDownJoValue/turnDownJob1.length);
        
        let { year, revenue, marketing_spend,google_spend } = revItem[0];
      
      let arr = [
        { List: 'Revenue', value: new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumIntegerDigits: 2, maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(Math.floor(revenue)) ,action: 1, rValue: revenue},
        { List: 'Marketing Spend', value: new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumIntegerDigits: 2, maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(Math.floor(marketing_spend)), action: 1, rValue: marketing_spend },
        { List: 'Google Spend', value: new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumIntegerDigits: 2, maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(Math.floor(google_spend)), action: 1, rValue: google_spend },
        {
          List: 'Marketing Spend (% of Revenue)',
          value: `${((marketing_spend / revenue) * 100).toFixed(2)} %`
        },
        { List: 'Total # Raw Leads', value: totallead },
        {
          List: 'Revenue per Lead Issued (SLI)',
          value: new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumIntegerDigits: 2, maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(Math.floor(revenue / totallead)),
        },
        { List: 'Cost per Lead', value: new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumIntegerDigits: 2, maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(Math.floor(marketing_spend / totallead)) },
        { List: 'Best Lead Source', value: bestLeadSource },
        { List: 'ROI from Best Lead Source', value:  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumIntegerDigits: 2, maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(Math.floor(RoiFromBLS))},
        { List: 'ROI from Worst Lead Source', value: RoiFromWLS || 0 },
        { List: '# of Referral/Personal Contacts', value: refPeronalContact },
        { List: '# of Google leads', value: googleLead },
        { List: '# of Repeat Customers', value: repeatCustomer },
        { List: 'Lead Conversion to CE', value: leadConvent },
        { List: '# of Conceptual Estimates', value: notionalEst },
        { List: 'Closing Sales Ratio (S.R.)', value: `${(closingSalesRatio * 100).toFixed(2)}%` },
        { List: 'Average Job Size (AJS)', value: new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumIntegerDigits: 2, maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(Math.floor(avJobSize)) }, 
        { List: 'Average Reno Size', value:  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumIntegerDigits: 2, maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(Math.floor(reniSizeVal)) },
        { List: 'Average Custom Home Size', value: new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumIntegerDigits: 2, maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(Math.floor(customHomeSize)) },
        { List: 'Total turned down jobs', value: new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumIntegerDigits: 2, maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(Math.floor(turnDownJoValue)) },
        { List: 'Average turned down jobs', value: new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumIntegerDigits: 2, maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(Math.floor(avTdVal)) }
      ];
      return arr;
    },
    getrevenueLeadsEmpty(revItem){
      let { year, revenue, marketing_spend } = revItem[0];
let arr = [
  { List: 'Revenue',value: new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumIntegerDigits: 2, maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(Math.floor(revenue)) ,action: 1, rValue: revenue},
  { List: 'Marketing Spend', value: new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumIntegerDigits: 2, maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(Math.floor(marketing_spend)), action: 1, rValue: marketing_spend},
  {
    List: 'Marketing Spend (% of Revenue)',
    value: `0 %`
  },
  { List: 'Total # Raw Leads', value: 0 },
  {
    List: 'Revenue per Lead Issued (SLI)',
    value: 0,
  },
  { List: 'Cost per Lead', value: 0},
  { List: 'Best Lead Source', value: 0 },
  { List: 'ROI from Best Lead Source', value:  0},
  { List: 'ROI from Worst Lead Source', value:  0 },
  { List: '# of Referral/Personal Contacts', value: 0 },
  { List: '# of Google leads', value: 0 },
  { List: '# of Repeat Customers', value: 0 },
  { List: 'Lead Conversion to CE', value: 0 },
  { List: '# of Conceptual Estimates', value: 0 },
  { List: 'Closing Sales Ratio (S.R.)', value: `0%` },
  { List: 'Average Job Size (AJS)', value: 0 }, 
  { List: 'Average Reno Size', value: 0 },
  { List: 'Average Custom Home Size', value: 0 },
  { List: 'Total turned down jobs', value: 0 },
  { List: 'Average turned down jobs', value: 0 }
];
return arr;
    },
    getMarketingList(leads, leadsSource, year){
      let arr = [];
      console.log('year--->',year)
      for (let i of leadsSource) { 

        // console.log(" i -----> ", i)
        // let leadCount = leads.filter((x) => i == x['lead_source'] && (x['contact_date'] ? x['contact_date'].substring(0, 4) : 0)==year).length;
        let leadCount = leads.filter((x) => i == x['lead_source'] && x['year']==year).length;
        if(i=='Magazine'){
          console.log('leadCount-->',leadCount)
        }
        let siteVisit = leads.filter((x) =>i == x['lead_source']  && (x['site_visit_date'] ? x['site_visit_date'].substring(0, 4) : 0)==year).length;
        let SiteVisitPercent = leadCount ? (siteVisit / leadCount * 100).toFixed(2) : 0;

        let CEVisit = leads.filter((x) => i == x['lead_source'] && (x['ce_sent_out'] ? x['ce_sent_out'].substring(0, 4) : 0)==year).length;
        let CEVisitPercent = leadCount ? (CEVisit / leadCount * 100).toFixed(2) : 0;

        let FsaCount = leads.filter((x) => i == x['lead_source'] && (x['fsa_date'] ? x['fsa_date'].substring(0, 4) : 0)==year).length;
        let FsaCountPercent = leadCount ? (FsaCount / leadCount * 100).toFixed(2) : 0;

        // let ContractCount = leads.filter((x) =>i == x['lead_source']  && (x['contract_date'] ? x['contract_date'].substring(0, 4) : 0)==year).length;

        let ContractCount = leads.filter((x) => {
          // Log each element (x) in the array to the console
        
        
          // The filter condition
          return i == x['lead_source'] && (x['contract_date'] ? x['contract_date'].substring(0, 4) : '0') == year;
        }).length;
      
        if(i=='Referral'){
          console.log('ContractCount-->',ContractCount)
        }
             
        // let ContractCountPercent = (siteVisit === 0 || !siteVisit) ? 0 : ((ContractCount || 0) / siteVisit * 100).toFixed(2);
        let ContractCountPercent = leadCount ? (ContractCount / leadCount * 100).toFixed(2) : 0;

        arr.push({
          'leadTrackerSource': i,
          'leadCount': leadCount,
          'siteVisit': siteVisit,
          'SiteVisitPercent': `${SiteVisitPercent}%`,
          'CEVisit': CEVisit,
          'CEVisitPercent': `${CEVisitPercent}%`,
          'FsaCount': FsaCount,
          'FsaCountPercent': `${FsaCountPercent}%`,
          'ContractCount': ContractCount,
          'ContractCountPercent': `${ContractCountPercent}%`,
        });
        
      }
      return arr;
    }


 
    
}
